import React from 'react';
import Moment from 'react-moment';

import {Article} from '../Services/ArticleService';

import AuthorLink from './AuthorLink';
import Crumb from './Crumb';

interface PostMetaProps {
  article: Article;
  footer: boolean;
  breadcrumb: boolean;
}

function PostMeta({article, footer, breadcrumb}: PostMetaProps) {
  const className = footer ? 'post-meta second-part' : 'post-meta';
  return (
    <div className={className}>
      <h5 className="title">
        {
          breadcrumb ? (
            <Crumb to="/public">Back to News</Crumb>
          ) : null
        }
        <div>
          <AuthorLink id={article.author.id}>{article.author.name}</AuthorLink> <Moment withTitle titleFormat="DD/MM/YYYY hh:mm" fromNow local date={article.date} />
        </div>
      </h5>
    </div>
  );
}

export default PostMeta;
